import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getPrePackSize } from "@faire/retailer-visitor-shared/features/PrePacks/getPrePackSize";
import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { isDiscontinued, isProductOptionInStock } from "@faire/retailer-visitor-shared/lib/productOptions";
import { getRequiredProductCustomizationsAdditionalCharge } from "@faire/retailer-visitor-shared/services/ProductCustomization";
import { logAssert } from "@faire/web--source/common/logging";
import { formatMoney } from "@faire/web--source/common/money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
var productWholesalePriceMoney = function(product, selectedOption, perStyleOptionVariation) {
    var _selectedOption_wholesale_price, _selectedOption_wholesale_promo_price_discounted_item_price, _selectedOption_wholesale_promo_price, _getRequiredProductCustomizationsAdditionalCharge;
    if (!selectedOption || isDiscontinued(product, selectedOption) || !((_selectedOption_wholesale_price = selectedOption.wholesale_price) === null || _selectedOption_wholesale_price === void 0 ? void 0 : _selectedOption_wholesale_price.amount_cents)) {
        return null;
    }
    var _selectedOption_wholesale_promo_price_discounted_item_price_amount_cents;
    var defaultOptionAmountCents = (_selectedOption_wholesale_promo_price_discounted_item_price_amount_cents = (_selectedOption_wholesale_promo_price = selectedOption.wholesale_promo_price) === null || _selectedOption_wholesale_promo_price === void 0 ? void 0 : (_selectedOption_wholesale_promo_price_discounted_item_price = _selectedOption_wholesale_promo_price.discounted_item_price) === null || _selectedOption_wholesale_promo_price_discounted_item_price === void 0 ? void 0 : _selectedOption_wholesale_promo_price_discounted_item_price.amount_cents) !== null && _selectedOption_wholesale_promo_price_discounted_item_price_amount_cents !== void 0 ? _selectedOption_wholesale_promo_price_discounted_item_price_amount_cents : selectedOption.wholesale_price.amount_cents;
    // we want to show the minimum of all options within the same style variant for open sizing.
    // using a reduce but the 'accumulator' will be the min price through math.min.
    if (perStyleOptionVariation) {
        var minVariationPrice = perStyleOptionVariation.reduce(function(minPrice, variation) {
            var _variation_wholesalePrice;
            var _variation_wholesalePrice_amount_cents;
            return Math.min(minPrice, (_variation_wholesalePrice_amount_cents = variation === null || variation === void 0 ? void 0 : (_variation_wholesalePrice = variation.wholesalePrice) === null || _variation_wholesalePrice === void 0 ? void 0 : _variation_wholesalePrice.amount_cents) !== null && _variation_wholesalePrice_amount_cents !== void 0 ? _variation_wholesalePrice_amount_cents : Infinity);
        }, Infinity);
        defaultOptionAmountCents = Math.min(minVariationPrice, defaultOptionAmountCents);
    }
    var _getRequiredProductCustomizationsAdditionalCharge_amount_cents;
    var price = IFaireMoney.build({
        amount_cents: defaultOptionAmountCents + ((_getRequiredProductCustomizationsAdditionalCharge_amount_cents = (_getRequiredProductCustomizationsAdditionalCharge = getRequiredProductCustomizationsAdditionalCharge(product.customizations || [])) === null || _getRequiredProductCustomizationsAdditionalCharge === void 0 ? void 0 : _getRequiredProductCustomizationsAdditionalCharge.amount_cents) !== null && _getRequiredProductCustomizationsAdditionalCharge_amount_cents !== void 0 ? _getRequiredProductCustomizationsAdditionalCharge_amount_cents : 0),
        currency: selectedOption.wholesale_price.currency
    });
    if (isPrePackProductOption(selectedOption)) {
        var prePackUnitCount = getPrePackSize(selectedOption.sizing_quantity);
        logAssert(prePackUnitCount !== 0 || !isNaN(prePackUnitCount), "Prepack unit count is invalid", {
            data: {
                selectedOption: selectedOption
            }
        });
        price = IFaireMoney.build(_object_spread_props(_object_spread({}, price), {
            amount_cents: price.amount_cents / prePackUnitCount
        }));
    }
    return price;
};
export var productWholesalePrice = function(strictLocalize, product, showTextWhenOutOfStock, selectedOption, perStyleOptionVariation) {
    if (selectedOption === undefined || isDiscontinued(product, selectedOption)) {
        return strictLocalize({
            id: "CJ6U5R",
            defaultMessage: [
                {
                    type: 0,
                    value: "(Unavailable)"
                }
            ]
        });
    }
    if (!isProductOptionInStock(selectedOption, perStyleOptionVariation) && showTextWhenOutOfStock) {
        return strictLocalize({
            id: "OxtSqw",
            defaultMessage: [
                {
                    type: 0,
                    value: "(Out of stock)"
                }
            ]
        });
    }
    var price = productWholesalePriceMoney(product, selectedOption, perStyleOptionVariation);
    if (!price) {
        return null;
    }
    return formatMoney({
        money: price
    });
};
